/**
 * @file Analytics related mutations.
 */

import gql from 'graphql-tag';

export const sendUserAction = gql`
  mutation sendUserAction($input: SendUserActionInput!) {
    sendUserAction(input: $input) {
      success
    }
  }
`;
